import '@/lib/sentry';
import '@/css/additional-styles/originui.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton/dist/skeleton.css';
import * as ReactDOM from 'react-dom/client';
import * as React from 'react';
import { App } from './app';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
      <App />
  </React.StrictMode>,
);
